import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/hooks/useAuth";
import { useBrandManager } from "@/hooks/useBrandManager";

interface GrowthGoal {
  id: string;
  name: string;
  description: string;
  brand_id: string;
  category: string;
  goal_type: string | null;
  created_at: string;
  updated_at: string;
}

export const useGrowthGoals2Y3X = () => {
  const [goals, setGoals] = useState<GrowthGoal[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const { user } = useAuth();
  const { currentBrandId } = useBrandManager();

  const fetchGoals = async () => {
    if (!user || !currentBrandId) {
      setGoals([]);
      return;
    }

    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('growth_metrics')
        .select('id, name, description, brand_id, category, goal_type, created_at, updated_at')
        .eq('brand_id', currentBrandId)
        .eq('category', '2Y3X Goal')
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      setGoals(data || []);
    } catch (error: any) {
      console.error('Error fetching goals:', error);
      toast({
        title: "Error",
        description: "Failed to fetch goals",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGoals();
  }, [user, currentBrandId]);

  return {
    goals,
    isLoading,
    refetch: fetchGoals,
  };
};
